import { useAuth } from "./useAuth";
import {
  canManageOnboarding, canManageUsers, canReadAudit, isManagementRole, canViewEmployees,
  canViewLaborCompliance, canManageArticle36, canReviewLaborCompliance, canManageNotices,
  canCreateEmployeeInvitation, canCreateManagementUser, canAssignManagementRole, canGrantExtraPermissions,
  canArchiveEmployee, canReactivateEmployee, canPreviewTestCleanup, canExecuteTestCleanup, canBulkTestCleanup,
  canManageMigration, canViewMigration, canViewScheduling, canManageShiftTemplates, canViewOwnSchedule,
  canEditSchedule, canApproveSchedule, canApproveShiftSwaps, canReviewAvailability, canManageRecruitment, canManageInterviews,
  canManageTimekeeping, canReviewTimecards, canLockPayrollTimecards, canTestDriveConnection,
  canPreparePayroll, canReviewPayroll, canPublishPayroll, canViewPayroll, canManageMedicalChecks,
  canManageTrainingContent, canPublishTraining, canApproveTrainingContent, canReviewTrainingSource,
  canAssignTraining, canWaiveTraining, canViewTraining, canManageLeave, canViewLeave,
  canManageWorkCalendar, canApproveWorkCalendar, canViewWorkCalendar,
  canRecordPaymentEvidence, canConfirmPaymentEvidence, canViewPaymentEvidence,
  canManagePayrollPackage, canManageDriveIngestion, canManageEmailDelivery,
  canViewManagerDigest, canViewDataQuality, canManageDataQuality,
  canManageHealthCommittee, canViewHealthCommittee,
  canManageLongHourInterview, canViewLongHourInterview, canViewPhysicianDetail,
  canManageCorrectiveAction, canViewCorrectiveAction,
  canManageSupplyPickup, canViewSupplyPickup,
  canManageStoreAccess, canGrantOrgWideScope, canReviewStoreAssignments, canTransferEmployeeStore,
  canViewSystemJobs, canManageSystemJobs, canViewProductionReadiness,
} from "../lib/permissions";

export function usePermissions() {
  const { user } = useAuth();
  const role = user ? user.role : null;
  return {
    role,
    user,
    isManagement: isManagementRole(role),
    canManageOnboarding: canManageOnboarding(role),
    canManageUsers: canManageUsers(role),
    canViewEmployees: canViewEmployees(role),
    canReadAudit: canReadAudit(role),
    canViewLaborCompliance: canViewLaborCompliance(role),
    canManageArticle36: canManageArticle36(role),
    canReviewLaborCompliance: canReviewLaborCompliance(role),
    canManageNotices: canManageNotices(role),
    canCreateEmployeeInvitation: canCreateEmployeeInvitation(role),
    canCreateManagementUser: canCreateManagementUser(user),
    canAssignManagementRole: canAssignManagementRole(user),
    canGrantExtraPermissions: canGrantExtraPermissions(role),
    canManageMigration: canManageMigration(role),
    canViewMigration: canViewMigration(role),
    canViewScheduling: canViewScheduling(role),
    canViewOwnSchedule: canViewOwnSchedule(role),
    canManageShiftTemplates: canManageShiftTemplates(role),
    canEditSchedule: canEditSchedule(role),
    canApproveSchedule: canApproveSchedule(role),
    canApproveShiftSwaps: canApproveShiftSwaps(role),
    canReviewAvailability: canReviewAvailability(role),
    canManageRecruitment: canManageRecruitment(role),
    canManageInterviews: canManageInterviews(role),
    canManageTimekeeping: canManageTimekeeping(role),
    canReviewTimecards: canReviewTimecards(role),
    canLockPayrollTimecards: canLockPayrollTimecards(role),
    canTestDriveConnection: canTestDriveConnection(role),
    canPreparePayroll: canPreparePayroll(role),
    canReviewPayroll: canReviewPayroll(role),
    canPublishPayroll: canPublishPayroll(role),
    canViewPayroll: canViewPayroll(role),
    canManageMedicalChecks: canManageMedicalChecks(role),
    canManageTrainingContent: canManageTrainingContent(role),
    canPublishTraining: canPublishTraining(role),
    canApproveTrainingContent: canApproveTrainingContent(role),
    canReviewTrainingSource: canReviewTrainingSource(role),
    canAssignTraining: canAssignTraining(role),
    canWaiveTraining: canWaiveTraining(role),
    canViewTraining: canViewTraining(role),
    canManageLeave: canManageLeave(role),
    canViewLeave: canViewLeave(role),
    canManageWorkCalendar: canManageWorkCalendar(role),
    canApproveWorkCalendar: canApproveWorkCalendar(role),
    canViewWorkCalendar: canViewWorkCalendar(role),
    canRecordPaymentEvidence: canRecordPaymentEvidence(role),
    canConfirmPaymentEvidence: canConfirmPaymentEvidence(role),
    canViewPaymentEvidence: canViewPaymentEvidence(role),
    canManagePayrollPackage: canManagePayrollPackage(role),
    canManageDriveIngestion: canManageDriveIngestion(role),
    canManageEmailDelivery: canManageEmailDelivery(role),
    canViewManagerDigest: canViewManagerDigest(role),
    canViewDataQuality: canViewDataQuality(role),
    canManageDataQuality: canManageDataQuality(role),
    canManageHealthCommittee: canManageHealthCommittee(role),
    canViewHealthCommittee: canViewHealthCommittee(role),
    canManageLongHourInterview: canManageLongHourInterview(role),
    canViewLongHourInterview: canViewLongHourInterview(role),
    canViewPhysicianDetail: canViewPhysicianDetail(role),
    canManageCorrectiveAction: canManageCorrectiveAction(role),
    canViewCorrectiveAction: canViewCorrectiveAction(role),
    canManageSupplyPickup: canManageSupplyPickup(role),
    canViewSupplyPickup: canViewSupplyPickup(role),
    canArchiveEmployee: canArchiveEmployee(role),
    canReactivateEmployee: canReactivateEmployee(role),
    canPreviewTestCleanup: canPreviewTestCleanup(role),
    canExecuteTestCleanup: canExecuteTestCleanup(user),
    canBulkTestCleanup: canBulkTestCleanup(user),
    canManageStoreAccess: canManageStoreAccess(role),
    canGrantOrgWideScope: canGrantOrgWideScope(user),
    canReviewStoreAssignments: canReviewStoreAssignments(role),
    canTransferEmployeeStore: canTransferEmployeeStore(role),
    canViewSystemJobs: canViewSystemJobs(role),
    canManageSystemJobs: canManageSystemJobs(role),
    canViewProductionReadiness: canViewProductionReadiness(role),
  };
}
